import { useCallback } from 'react';
import type {
	ChildResult,
	CommandSections,
} from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { QUICK_SEARCH_PRIORITY } from '../../../../../common/ui/constants.tsx';
import { useGetQuickSearchFilterCommands } from '../../../../../common/ui/filter/index.tsx';
import type {
	GetQuickSearchChildResultProps,
	UseGetChildResult,
} from '../../../../../common/ui/types.tsx';
import { SECTION_ID } from './constants.tsx';
import { messages } from './messages.tsx';

export const useGetSearchFiltersChildResult: UseGetChildResult = () => {
	const { formatMessage } = useIntl();

	const { getQuickSearchFilterCommands } = useGetQuickSearchFilterCommands({
		section: SECTION_ID,
		showViewAll: true,
	});
	const getChildResult = useCallback(
		(props: GetQuickSearchChildResultProps): ChildResult => {
			const sections: CommandSections = {
				[SECTION_ID]: {
					id: SECTION_ID,
					name: formatMessage(messages.filters),
					priority: QUICK_SEARCH_PRIORITY.FILTERS,
				},
			};

			const commands = getQuickSearchFilterCommands(props);

			return {
				sections,
				commands,
			};
		},
		[formatMessage, getQuickSearchFilterCommands],
	);

	return { getChildResult };
};
